
<template>
  <div name="assessmentoutcomes">
    <noaccess v-if="!hasAccess" :blocktype="'outcome'"></noaccess>

    <div v-else>
      <FilterBar @searchChanged="setSearchValue">
        <template v-slot:filter>
          <div>
            <Dropdown
              :options="yearDropdown"
              :selected="filteredYear"
              :title="'Year Group'"
              v-on:updateOption="setYearValue"
              style="min-width: 12rem"
            ></Dropdown>
          </div>
        </template>
        <template v-slot:actions>
          <div>
            <button
              type="button"
              class="action-button hover:opacity-75"
              @click="addNew()"
            >
              <i class="fas fa-plus"></i>
              Add New
            </button>
          </div>
        </template>
      </FilterBar>

      <p v-if="showMessage" class="save-notice ml-6 mb-4">
        {{ msg }} <i class="far fa-check-circle"></i>
      </p>

      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Outcomes</p>
      </div>

      <table
        class="w-95p mx-auto mb-2 h-12 pt-2 align-text-bottom bg-white rounded text-left text-gray-400"
      >
        <thead class="bg-gray-100 w-full">
          <tr>
            <th class="w-1/12 text-left px-4">Criteria</th>
            <th class="w-5/12">Detail</th>
            <th class="w-1/12 text-left">Type</th>
            <th class="w-2/12 text-left">In Years</th>

            <th class="w-1/12 text-center">Active</th>
            <th class="w-1/12"></th>
          </tr>
        </thead>
      </table>

      <div class="table-wrapper">
        <div v-if="errored" class="empty m-4 pl-4 font-bold">
          <p>
            We are not able to retrieve this information at the moment, please
            try back later
          </p>
        </div>

        <div id="content-area" v-else>
          <table
            v-if="componentLoaded"
            class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm"
          >
            <tbody>
              <tr
                class="course"
                v-for="item in filteredList"
                :key="item.identifier"
              >
                <td class="w-1/12 text-xs text-left">
                  <div class="pl-3 block opacity-50">
                    {{ parseCriteria(item.criteria) }}
                  </div>
                </td>

                <td class="w-5/12 text-xs">{{ item.title }}</td>
                <td class="w-1/12 text-xs">
                  {{ item.unit_only === 0 ? "All Units" : "Course based" }}
                </td>
                <td class="center w-2/12">{{ showYears(item) }}</td>
                <td class="w-1/12 text-center">
                  <i
                    class="icon list"
                    v-bind:class="setActiveClass(item.active)"
                  />
                </td>
                <td class="w-1/12 tb-actions text-center">
                  <a
                    v-on:click="showOutcome(item)"
                    class="text-button orange-text"
                    >Edit</a
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <p class="m-5 mx-12" v-else>
            We could not find any data for your given selection.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const Dropdown = () => import("@/components/Dropdown.vue");
const noaccess = () => import("@/components/NoAccess.vue");
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";
import { OutcomeService } from "@/services/outcome.service";

export default {
  name: "assessmentoutcomes",
  mixins: [yearGroupMixin],
  props: {
    msg: { type: String, required: false },
    subject:  { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    componentLoaded() {
      return this.filteredList.length > 0;
    },
    hasAccess() {
      return (
        this.currentAccess.outcomeAccess ||
        this.currentUser.isOrganisation ||
        this.currentUser.isContentAdmin
      );
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    yearDropdown() {
      return this.years;
    },
    criteriaList() {
      if (this.settings.assessmentCriteriaList.length > 0) {
        return this.settings.assessmentCriteriaList;
      }
    },
    yearDropdown() {
      var results = [{ id: 0, name: "All" }].concat(this.years);
      this.filteredYear = results[0];
      return results;
    },
    orderedOutcomes() {
      var vm = this;
      let year = vm.filteredYear;
      var criteriaValues = vm.filteredCriteria;

      if (year.id == 0 && criteriaValues.length == 0) {
        return _.orderBy(this.outcomes, ["criteria", "display_order", "title"]);
      } else {
        var filtered = vm.outcomes.filter((object) => {
          let filtered = true;

          // if (year.id > 0) {
          //   if (object.years == null) {
          //     object.years = [];
          //   }

          //   let outcomeYears = object.years.map((y) => y.id);
          //   filtered = outcomeYears.some((v) => years.includes(v));
          // }

          if (filtered && criteriaValues.length > 0) {
            filtered = criteriaValues.includes(object.criteria);
          }

          return filtered;
        });
        return _.orderBy(filtered, ["criteria", "display_order", "title"]);
      }
    },
    filteredList() {
      return this.orderedOutcomes.filter((item) => {
        var vm = this;
        return item.title.toLowerCase().includes(vm.search.toLowerCase());
      });
    },
  },
  data() {
    return {
      errored: false,
      loading: false,
      selectAll: false,
      showFilter: false,
      filteredCriteria: [],
      outcomes: [],
      filteredYear: {},
      filteredCat: {},
      search: "",
    };
  },
  created() {
    this.loading = true;

    this.fetchData();
  },
  mounted() {},
  watch: {
    '$props':{
      handler: function (val, oldVal) { 
        this.fetchData()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      OutcomeService.getPrivate(this.subject.id)
        .then((response) => (this.outcomes = response.data.data))
        .catch((err) => {
          console.log("Outcomes " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    setActiveClass(active) {
      if (active == 1) {
        return "fas fa-check-circle true";
      } else {
        return "fas fa-times-circle false";
      }
    },
    addNew() {
      var outcome = {};
      outcome.subject_id = this.subject.id
      this.$router.push({
        name: "OutcomeEdit",
        params: {
          outcome: outcome,
          newAddition: true,
          years: this.years,
          order: this.outcomes.length + 1,
        },
      });
      window.scrollTo(0, 0);
    },
    showOutcome(object) {
      this.$router.push({
        name: "OutcomeEdit",
        params: {
          outcome: object,
          newAddition: false,
          years: this.years,
          order: this.outcomes.length + 1,
        },
      });
    },
    parseCriteria(val) {
      let outcomeCriteria = val
        .replace("performance", "criteria_1")
        .replace("collaboration", "criteria_2")
        .replace("competition", "criteria_3");

      let ct = this.settings.assessmentCriteriaList
        .filter((criteria) => {
          return outcomeCriteria === criteria.key;
        })
        .shift();
      return ct == undefined ? "N/A" : ct.value;
    },
    setFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter == false) {
        this.filteredYears = [];
        this.filteredCriteria = [];
      }
    },
    setSearchValue(value) {
      this.search = value;
    },
    setYearValue(value) {
      this.filteredYear = value;
    },
    showYears(outcome) {
      let vm = this
      if (outcome.years === undefined) {
        return "Unkown";
      }
      
      let yearsParsed = outcome.years.flatMap(function (item) {
        let found = vm.getYearGroupFromId(item.id);
        return found != undefined ? found.letter : [];
      });

      return yearsParsed.join(", ")

    },
    filterCriteriaKey(key) {
      if (this.filteredCriteria.includes(key)) {
        this.filteredCriteria.splice(this.filteredCriteria.indexOf(key), 1);
      } else {
        this.filteredCriteria.push(key);
      }
    },
    inCriteriaFilter(key) {
      return this.filteredCriteria.includes(key);
    },
  },
  components: {
    Dropdown,
    FilterBar,
    noaccess,
  },
};
</script>


<style scoped>
</style>
